import styled from 'styled-components';
import { MenuItem } from '@mui/material';

import colors from '../../../../../../../styles/colors';

const DangerMenuItem = styled(MenuItem)`
  color: ${colors.base.danger};
  svg {
    color: ${colors.base.danger};
  }
`;

const MenuItemLabel = styled.span`
  font-size: 13px;
`;

export {
  DangerMenuItem,
  MenuItemLabel,
};
